<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<form
  (ngSubmit)="searchMasterData()"
  #searchForm="ngForm"
  class="flex items-center w-2/4 pb-4"
>
  <nz-input-group nzSearch nzSize="large" [nzAddOnAfter]="suffixButtons">
    <input
      type="text"
      name="mId"
      [(ngModel)]="mId"
      nz-input
      placeholder="Search master data by m_id"
      required
    />
  </nz-input-group>

  <ng-template #suffixButtons>
    <button
      nz-button
      nzType="primary"
      nzSize="large"
      nzSearch
      type="submit"
      [disabled]="loading"
    >
      Search
    </button>
    <button
      nz-button
      nzSize="large"
      type="button"
      class="ml-2"
      (click)="clear()"
    >
      Clear
    </button>
  </ng-template>
</form>

<nz-spin [nzSpinning]="loading" nzTip="Searching master data...">
  <div *ngIf="loading" class="h-32 w-full"></div>

  <div *ngIf="!loading && searched && result" class="bg-gray-100 p-4">
    <div *ngIf="result" class="bg-gray-100 p-4">
      <nz-card nzTitle="Master Data Details">
        <nz-descriptions nzBordered nzSize="small" [nzColumn]="1" class="w-1/2">
          <nz-descriptions-item nzTitle="Master Data Type">
            {{ result.masterDataType }}
          </nz-descriptions-item>
          <nz-descriptions-item nzTitle="Master Data Category">
            {{ result.masterDataCategory }}
          </nz-descriptions-item>
          <nz-descriptions-item nzTitle="Array Index">
            {{ result.masterDataIndex }}
          </nz-descriptions-item>
        </nz-descriptions>

        <nz-divider nzText="Master Data Item"></nz-divider>

        <pre class="bg-white p-3 rounded">
      {{ result.masterData | json }}
          </pre
        >
      </nz-card>
    </div>
  </div>
</nz-spin>
